var Plugin = {};
Plugin.install = function(Vue, options) {
	Vue.prototype.load = function() {
		const serverSrc = 'www.baidu.com';

		var titles = document.getElementsByClassName("right_content_details");
		for(var i = 0; i < titles.length; i++) {
			$clamp(titles[i], {
				clamp: 2
			});
		}
		var titls = document.getElementsByClassName("informationCollection_name");
		for(var i = 0; i < titls.length; i++) {
			$clamp(titls[i], {
				clamp: 1
			});
		}
		$("body").on('click', '[data-stopPropagation]', function(e) {
			e.stopPropagation();
		});

		$(".right_information_dropdown .videotab").click(function (){

	　　　　	$(this).addClass("videotabbor").siblings().removeClass("videotabbor");

	　　	});

		//超出出现滚动条
		var browser_height = $(window).height(); //浏览器高度
		var header_height = 60;
		var right_content_height = browser_height - 60 - 16;
		var nonegauge_height = browser_height - 60;
		$(".centre_content").css('height', right_content_height);
		// $(".centre_content").height();
		var video_breviary_height = right_content_height - 45 - 59;
		var one_title_nano = right_content_height - 65;
		// var counsel_institution = right_content_height - 65 - 90;
		var counsel_institution = right_content_height;
		$(".counsel_institution").css('height', counsel_institution);
		$(".one_title_nano_middle").css('height', one_title_nano);	// 中间栏高度设置
		$(".one_title_nano").css('height', one_title_nano);
		$('.video_breviary').css('height', video_breviary_height);
		$('.video_breviary').height();
		$(".nano").nanoScroller('height', counsel_institution);
		$(".none_gauge").css('height',right_content_height);

        var right_content_heights = browser_height - 65 - 16;
        $(".height-setting").css('height', right_content_heights);
		
		var _width = $(window).width();
		if(_width < 768) {
			$('.nano').removeClass('nano');
			$('.video_breviary').removeClass('nano');
			$('.centre_content').removeClass('nano');
		}

		/*个人中心*/
		$('#myTabs a').click(function(e) {
			e.preventDefault()
			$(this).tab('show');
		});
	}
};
export default Plugin;
